const isHolidaySeason = () => {
    const currentDate = new Date()

    const currentMonth = currentDate.getMonth() // 0-11 (0 = January, 11 = December)
    const currentDay = currentDate.getDate() // 1-31

    // Holiday season: Dec 1-31 (month 11) OR Jan 1-6 (month 0, days 1-6)
    const isDecember = currentMonth === 11
    const isEarlyJanuary = currentMonth === 0 && currentDay <= 6

    return isDecember || isEarlyJanuary
}

export default isHolidaySeason
